import { render, staticRenderFns } from "./answer-identity.vue?vue&type=template&id=ec9d9a38&scoped=true&"
import script from "./answer-identity.vue?vue&type=script&lang=js&"
export * from "./answer-identity.vue?vue&type=script&lang=js&"
import style0 from "./answer-identity.vue?vue&type=style&index=0&id=ec9d9a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9d9a38",
  null
  
)

export default component.exports